import React, { useState } from 'react'
import { motion } from 'framer-motion';
import { FaRobot } from "react-icons/fa";
import { FaLightbulb } from "react-icons/fa";
import { BsGraphUpArrow } from "react-icons/bs";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { FaHandshakeAngle } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";

const CompanyPage = () => {

  const [activeTab, setActiveTab] = useState('efficiency')
  const [openPositions, setOpenPositions] = useState(false)
  const [openInternships, setOpenInternships] = useState(false)
  const [openReason, setOpenReason] = useState(false)
  const tabContent = {
    efficiency: "Our bots streamline processes, reducing manual work and increasing overall efficiency.",
    productivity: "With QualBots, your team can focus on high-value tasks while our bots handle repetitive work.",
    satisfaction: "Improved response times and 24/7 availability lead to higher customer satisfaction rates."
  }

  return (
    <div>
      {/* Company overview section 1 */}
      <div className='flex flex-col sm:flex-row justify-between px-10 md:px-24  items-center lg:space-x-20 space-y-8 lg:space-y-0 m-2'>

        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className='w-full lg:w-[60%]'>
          <p className='text-[#d38f24] text-4xl font-bold mt-8 mb-8'>QualBots: Pioneering the Future of Automation</p>
          <p className='text-[#0b1437] text-2xl  font-semibold mb-8'>Innovative solutions for a rapidly evolving digital landscape.</p>
          <p className=' text-xl'>At QualBots, we are committed to transforming industries through cutting-edge
            automation technology. Our journey began with a vision to empower businesses with
            intelligent bots tailored to their unique needs. With a dedicated team of experts,
            we have cultivated a culture of innovation and excellence, striving to provide our
            clients with solutions that enhance efficiency, productivity, and customer satisfaction.
          </p>

        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className='w-full lg:w-[40%]'>
          <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6ytK7MgtVZyw1MGOsX1OswvMpbV8XyKjoYg&s'
            alt='Qualbots team'
            className='mt-12 rounded-lg object-cover w-full h-full' />
        </motion.div>

      </div>

      <div className='bg-white py-20 mt-10 '>

        <motion.p
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className='text-3xl text-[#d38f24] font-bold text-center mb-12'
        >
          Why Choose QualBots?
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className='grid grid-cols-1 md:grid-cols-3 gap-8 mx-10'>

          <div className='bg-white shadow-lg rounded-lg p-6'>
            <div className='flex items-center gap-2 mb-2'>
              <FaRobot className='text-3xl text-[#d38f24]' />
              <p className='text-2xl text-[#0b1437] font-semibold'> Cutting-Edge AI </p>
            </div>
            <p className='text-lg'>Our bots leverage the latest in artificial intelligence to provide smart, adaptive solutions.</p>
          </div>

          <div className='bg-white shadow-lg rounded-lg p-6'>
            <div className='flex items-center gap-2 mb-2'>
              <FaLightbulb className='text-3xl text-[#d38f24]' />
              <p className='text-2xl text-[#0b1437] font-semibold'> Innovative Approach </p>
            </div>
            <p className='text-lg'>We constantly push the boundaries of what's possible in automation technology.</p>
          </div>

          <div className='bg-white shadow-lg rounded-lg p-6'>
            <div className='flex items-center gap-3 mb-2'>
              <BsGraphUpArrow className='text-2xl stroke-1 text-[#d38f24]' />
              <p className='text-2xl text-[#0b1437] font-semibold'> Proven Results </p>
            </div>
            <p className='text-lg'>Our solutions have demonstrably improved efficiency and productivity for our clients.</p>
          </div>

        </motion.div>

      </div>


      <div className='bg-gray-200 py-16'>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className='container mx-auto '>

          <p className='text-3xl font-bold text-center text-[#0b1437] mb-12'>Benefits of QualBots</p>

          <div className='flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4 mb-10 px-2'>
            <button
              className={`px-4 py-2 rounded-full ${activeTab === 'efficiency' ? 'bg-[#d38f24] text-white' : 'bg-gray-300 text-gray-700'}`}
              onClick={() => setActiveTab('efficiency')}
            >
              Efficiency
            </button>
            <button
              className={`px-4 py-2 rounded-full ${activeTab === 'productivity' ? 'bg-[#d38f24] text-white' : 'bg-gray-300 text-gray-700'}`}
              onClick={() => setActiveTab('productivity')}>
              Productivity
            </button>
            <button
              className={`px-4 py-2 rounded-full ${activeTab === 'satisfaction' ? 'bg-[#d38f24] text-white' : 'bg-gray-300 text-gray-700'}`}
              onClick={() => setActiveTab('satisfaction')}>
              Customer Satisfaction
            </button>

          </div>

          <div key={activeTab} className='bg-white mb-5 rounded-xl shadow-xl w-full md:w-1/2 mx-auto'>
            <p className="text-gray-700 text-center text-lg p-4">{tabContent[activeTab]}</p>
          </div>

        </motion.div>

      </div>

      {/* Careers section 2 */}

      <div className='mt-10 p-2'>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className='flex justify-center items-center flex-col'>
          <p className='text-[#d38f24] text-4xl font-bold mt-6 mb-8'>Join Our Team</p>
          <p className='text-[#0b1437] text-2xl  font-semibold mb-8'>Be part of a dynamic team that is shaping the future of automation.</p>
          <p className='max-w-3xl text-xl text-gray-800 mb-8'>At QualBots, we believe our people are our greatest asset. We are always on the lookout for talented individuals who are passionate about technology and innovation. If you are driven, creative, and eager to make a difference, we invite you to explore our current job openings and apply to join our team.</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className='flex flex-col justify-center items-center gap-5'>

          <div className='w-full md:w-3/4'>
            <button className='w-full flex justify-between items-center bg-white p-5 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300'
              onClick={() => setOpenPositions(!openPositions)}
            >
              <span className='text-xl font-medium text-[#0b1437]'>Open Fulltime Positions</span>
              {openPositions ? <FaChevronUp className='text-[#d38f24] text-xl' /> : <FaChevronDown className='text-[#d38f24] text-xl' />}
            </button>

            {openPositions && <div className='bg-white mt-2 rounded-xl shadow-inner overflow-hidden'>
              <li className='p-3 mx-2 mt-1 rounded-xl list-none hover:bg-gray-100'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Software Engineer</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    View Full Job Description
                  </a>
                </div>
              </li>

              <li className='p-3 mx-2 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Product Manager</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    View Full Job Description
                  </a>
                </div>
              </li>

              <li className='p-3 mx-2 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Marketing Specialist</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    View Full Job Description
                  </a>
                </div>
              </li>
            </div>}

          </div>

          <div className='w-full md:w-3/4'>
            <button className='w-full flex justify-between items-center bg-white p-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 '
              onClick={() => setOpenInternships(!openInternships)}
            >
              <span className='text-xl font-medium text-[#0b1437]'>Open Internships</span>
              {openInternships ? <FaChevronUp className='text-[#d38f24] text-xl' /> : <FaChevronDown className='text-[#d38f24] text-xl' />}
            </button>

            {openInternships && <div className='bg-white mt-2 rounded-xl shadow-inner overflow-hidden'>
              <li className='p-3 mx-2 mt-1 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>UI/UX Intern</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    View Full Job Description
                  </a>
                </div>
              </li>

              <li className='p-3 mx-2 mt-1 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Sales & Marketing Intern</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    View Full Job Description
                  </a>
                </div>
              </li>

              <li className='p-3 mx-2 mt-1 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Data Science Intern</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    View Full Job Description
                  </a>
                </div>
              </li>
            </div>}
          </div>


          <div className='w-full md:w-3/4'>
            <button className='w-full flex justify-between items-center bg-white p-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300'
              onClick={() => setOpenReason(!openReason)}
            >
              <span className='font-medium text-[#0b1437] text-xl'>Why Work at Qualbots</span>
              {openReason ? <FaChevronUp className='text-[#d38f24] text-xl' /> : <FaChevronDown className='text-[#d38f24] text-xl' />}
            </button>

            {openReason && <div className='bg-white mt-2 rounded-xl shadow-inner overflow-hidden'>
              <li className='p-3 mx-2 mt-1 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Company Culture</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Read More
                  </a>
                </div>
              </li>

              <li className='p-3 mx-2 mt-1 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Employee Benefits</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300  hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Read More
                  </a>
                </div>
              </li>

              <li className='p-3 mx-2 mt-1 rounded-xl list-none hover:bg-gray-50'>
                <div className='flex justify-between items-center'>
                  <span className='text-lg'>Career Development Opportunities</span>
                  <a
                    href="/"
                    className="text-[#d38f24] hover:text-[#0b1437] transition-colors duration-300 hover:underline underline-offset-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Read More
                  </a>
                </div>
              </li>
            </div>}
          </div>



        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className='flex justify-center items-center mt-8  transition-colors duration-300 mb-12'>
          <button className='flex  items-center bg-[#d38f24] text-white px-10 py-3 rounded-full font-semibold text-lg hover:bg-[#0b1437]'>
            View All Careers
            <span> <FaArrowRight className='ml-3 text-lg' /> </span>
          </button>
        </motion.div>

      </div>

      {/* Privacy Section 3 */}

      <div className='bg-white p-2'>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className='flex flex-col justify-center items-center pt-10'>
          <FaLock className='text-[#d38f24] text-3xl mb-2' />
          <p className='text-[#0b1437] text-4xl font-semibold mt-6 mb-6'>Your Privacy Matters to Us</p>
          <p className='text-2xl font-semibold mb-6'>Understanding our commitment to protecting your information.</p>
          <p className='text-xl max-w-3xl mb-8'>At QualBots, we are dedicated to maintaining the privacy and security of our users’ information. Our Privacy Policy outlines how we collect, use, and protect your data when you engage with our services. We encourage you to read our full policy to understand your rights and our responsibilities.</p>
          <button className='bg-[#d38f24] text-white px-10 py-3 rounded-full font-semibold text-lg hover:bg-[#0b1437] mb-12'>Read Our Privacy Policy</button>

        </motion.div>

      </div>

      {/* Terns of Usage section 4 */}

      <div className='p-2.5'>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className='flex flex-col justify-center items-center pt-10'>
          <p className='text-[#0b1437] text-4xl font-semibold mt-6 mb-6'>Understanding Your Rights and Responsibilities</p>
          <p className='text-2xl font-semibold mb-6'>The legal framework that governs your use of our services.</p>
          <p className='text-xl max-w-2xl mb-8'>Our Terms of Use define the terms under which you may access and use our services. By engaging with QualBots, you agree to comply with these terms. We recommend reviewing our Terms of Use to understand your rights and obligations when utilizing our platform.</p>
          <button className='bg-[#d38f24] text-white px-10 py-3 rounded-full font-semibold text-lg hover:bg-[#0b1437] mb-12'>Read Our Terms of Use</button>
        </motion.div>

      </div>

      {/* Company Values section 5 */}

      <motion.div
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.8 }}
        className='bg-white pb-5'>

        <div className='flex flex-col justify-center items-center p-2'>
          <p className='text-[#d38f24] text-4xl font-semibold mt-6 mb-6'>Our Core Values</p>
          <p className='text-2xl font-semibold mb-6'>Guiding principles that shape our culture and decisions.</p>
          <p className='text-xl max-w-3xl mb-6'>At QualBots, our core values define who we are and guide our actions. They serve as a compass for our interactions with clients, partners, and each other.</p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-4 gap-5 p-5 mb-8 mx-8'>
          <div className='bg-blue-50 p-3 rounded-xl'>
            <div className='flex items-center mb-2'>
              <FaLightbulb className='text-2xl text-[#d38f24]' />
              <p className='text-xl font-semibold ml-2'>Innovation</p>
            </div>
            <p className='text-lg'>We strive to push the boundaries of technology.</p>
          </div>

          <div className='bg-blue-50 p-3 rounded-xl'>
            <div className='flex items-center mb-2'>
              <IoCheckmarkDoneSharp className='text-2xl stroke-2 text-[#d38f24]' />
              <p className='text-xl font-semibold ml-2'>Integrity</p>
            </div>
            <p className='text-lg'>We conduct our business with honesty and transparency.</p>
          </div>

          <div className='bg-blue-50 p-3 rounded-xl'>
            <div className='flex items-center mb-2'>
              <FaHandshakeAngle className='text-2xl text-[#d38f24]' />
              <p className='text-xl font-semibold ml-2'>Collaboration</p>
            </div>
            <p className='text-lg'>We believe in teamwork and collective success.</p>
          </div>

          <div className='bg-blue-50 p-3 rounded-xl'>
            <div className='flex items-center mb-2'>
              <FaUsers className='text-2xl text-[#d38f24]' />
              <p className='text-xl font-semibold ml-2'>Customer Focus</p>
            </div>
            <p className='text-lg'>Our clients are at the heart of everything we do.</p>
          </div>

        </div>

      </motion.div>

      {/* Contact us section 6 */}

      <div>

        <div className='flex flex-col md:flex-row gap-5 mx-6 my-12'>

          <motion.div 
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className='w-full md:w-1/2 ml-5'>
            <p className='text-[#d38f24] text-4xl font-bold mb-8'>We'd Love to Hear From You!</p>
            <p className='text-2xl max-w-3xl font-semibold mb-8'>Reach out to learn more about our services or discuss potential collaborations.</p>
            <p className='text-xl max-w-3xl mb-6'>Whether you have questions, feedback, or partnership inquiries, our team is here to assist you. Fill out the form below, and we will get back to you promptly.</p>
          </motion.div>

          <motion.div 
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className='w-full md:w-2/5 bg-white p-6 rounded-xl'>
            <p className='text-2xl text-[#0b1437] font-semibold mb-4'>Send us a Message</p>
            <form className='flex flex-col'>
              <input
                type='text'
                placeholder='Enter your Name'
                className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none mb-3'
              />

              <input
                type='email'
                placeholder='Enter your Email'
                className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none mb-3'
              />

              <input
                type='text'
                placeholder='Enter Message'
                className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none mb-3'
              />

              <div className='flex items-center justify-center w-full bg-[#d38f24] text-white py-3 px-4 mb-2 rounded-md hover:bg-[#0b1437] transition-colors duration-300'>
                <button type='submit' className="text-lg font-semibold">
                  Send Message
                </button>
                <IoIosSend className='text-lg ml-2' />
              </div>
            </form>

          </motion.div>

        </div>

      </div>

    </div>
  )
}

export default CompanyPage